import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import {GroupOption, MenuOption, NonGroupOption} from "../../../types";
import {ContextMenuHelperService} from "../title-context-menu/context-menu-helper.service";

@Component({
  selector: 'menu-options-component',
  templateUrl: './menu-options.component.html',
  styleUrls: ['./menu-options.component.css']
})
export class MenuOptionsComponent implements OnInit, OnChanges {
  @Input() options: MenuOption[] = [];
  @Input() value: any = {};
  @Output() valueChange = new EventEmitter<any>();

  constructor(
    private context_menu_service: ContextMenuHelperService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.initializeDefaults(this.options, this.value);
  }

  ngOnChanges(changes: SimpleChanges) {
    // Force re-initialization when options input changes to apply new defaultValues
    if (changes.options && !changes.options.firstChange) {
      this.updateValuesSelective(changes.options.currentValue, changes.options.previousValue, this.value);
    } else if (changes.options && changes.options.firstChange) {
       this.initializeDefaults(this.options, this.value);
    }

    // When value input changes, update the local value reference
    if (changes.value) {
      if (!changes.value.firstChange) {
        // Directly assign the new value reference from parent
        // This ensures checkbox bindings reflect the updated state
        this.value = changes.value.currentValue;

        // Manually trigger change detection to update ngModel bindings
        this.cdr.detectChanges();
      }
    }
  }

   updateValuesSelective(newOptions: MenuOption[], oldOptions: MenuOption[], target: any) {
     if (!newOptions) return;

  for(const newOpt of newOptions) {

    const key = (newOpt as any).field || newOpt.label;
    const oldOpt = oldOptions?.find(o => ((o as any).field || o.label) === key);

    if (newOpt.showLabel === undefined) newOpt.showLabel = true;

    // this section will handle for group or ICAO group
    // refer menu_config.ts to understand structure and defaults
    if ((newOpt.type === 'group' || newOpt.type === 'group-mode-checkbox') && newOpt.options) {
      const nextTarget = (newOpt as any).field ? target[(newOpt as any).field] : target;
      this.updateValuesSelective(newOpt.options, oldOpt?.options, nextTarget);
      continue;
    }

    const field = (newOpt as NonGroupOption).field;

    if (newOpt.type === 'multi-checkbox') {

      target[field] = target[field] || {};

      const newDefaults = (newOpt as any).defaultValue || [];
      const oldDefaults = (oldOpt as any)?.defaultValue || [];

      const defaultsChanged =
        newDefaults.length !== oldDefaults.length ||
        oldDefaults.some(v => !newDefaults.includes(v));

      for (const val of newOpt.values || []) {
        const newDefault = newDefaults.includes(val);

        if (target[field][val] === undefined || defaultsChanged) {
          target[field][val] = newDefault;
        }
      }

      continue;
    }

    const newDefault = newOpt.type === 'boolean' ? (newOpt.defaultValue || false) : ((newOpt as NonGroupOption).defaultValue ?? '');

    const oldDefault =oldOpt ? (oldOpt.type === 'boolean' ? (oldOpt.defaultValue || false) : ((oldOpt as NonGroupOption).defaultValue ?? '')): undefined;

    if (target[field] === undefined || newDefault !== oldDefault) {
      target[field] = newDefault;
    }
  }
  }

  initializeDefaults(options: MenuOption[], target: any, forceUpdate: boolean = false) {
    options.forEach(option => {
      if(option.showLabel === void 0) {
        option.showLabel = true;
      }

      if ((option.type === 'group' || option.type === 'group-mode-checkbox') && option.options) {
        this.initializeDefaults(option.options, this.value, forceUpdate);
      } else {
        if (option.type === 'multi-checkbox') {
          // Initialize the object if it doesn't exist
          target[option.field] = target[option.field] || {};

          // Force update checkbox states based on new defaultValue
          option.values?.forEach(val => {
            if (forceUpdate || target[option.field][val] === undefined) {
              target[option.field][val] = option.defaultValue
                ? option.defaultValue.includes(val)
                : false;
            }
          });
        } else {
          // For non-checkbox types, only set if undefined (unless forcing update)
          if (forceUpdate || target[(option as NonGroupOption).field] === undefined) {
            target[(option as NonGroupOption).field] =
              (option.type === 'boolean' ? (option.defaultValue || false) : (option as NonGroupOption).defaultValue ?? '');
          }
        }
      }
    });
  }

  onValueChange(field:string) {
    if (field === 'undefined') {
       return;
    }
    this.context_menu_service.value_change(field, this.value);
    this.valueChange.emit(this.value);
  }

  handleGroupChange(event: any, field: string) {
    if (field) {
      this.value[field] = event;
      this.onValueChange(field);
    } else {
      Object.assign(this.value, event);
      this.valueChange.emit(this.value);
    }
  }

  trackOption(index: number, item: MenuOption) {
    return (item as any).field ? (item as any).field : item.label;
  }

  getBooleanOption(options: MenuOption[]) {
  return options.find(o => o.type === 'boolean');
}

getMultiCheckboxOption(options: MenuOption[]) {
  return options.find(o => o.type === 'multi-checkbox');
}

  onGroupOpened(field: string): void {
  }
}
